import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/employees/profile/$employeeId')({
  staticData: { breadcrumb: 'Employee Profile', breadcrumbKey: 'K_BREADCRUMB_EMPLOYEE_PROFILE' },
  validateSearch: (search: Record<string, unknown>): { edit?: boolean } => {
    if (search.edit === true || search.edit === 'true') return { edit: true };
    return {};
  },
});
